var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "videoGeneration" }, [
    !_vm.clipTask.length
      ? _c("div", { staticClass: "task-no-data" }, [
          _vm._m(0),
          _c("div", [_vm._v("暂无内容")]),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "videoGenerationContent" },
      [
        _c(
          "scrollPane",
          { staticStyle: { height: "100%" } },
          _vm._l(_vm.clipTask, function (item) {
            return _c("div", { key: item.id, staticClass: "p-l-20 p-r-20" }, [
              _c("div", { staticClass: "task-child-clip" }, [
                _c("div", { staticClass: "task-child-clip-l" }, [
                  _c("img", {
                    staticClass: "task-child-clip-l-icon",
                    attrs: {
                      src: require("@/icons/svg/t_creation_video.svg"),
                      alt: "",
                    },
                  }),
                ]),
                _c("div", { staticClass: "task-child-clip-r" }, [
                  _c("div", { staticClass: "task-child-clip-r-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(item.projectName) +
                        "： " +
                        _vm._s(item.name) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "task-child-clip-r-status" }, [
                    _c("div", [
                      item.status === 1
                        ? _c("span", { staticClass: "task-color-green" }, [
                            _vm._v("生成成功"),
                          ])
                        : item.status === 2
                        ? _c("span", { staticClass: "task-color-red" }, [
                            _vm._v("生成失败"),
                          ])
                        : item.status === 3
                        ? _c("span", { staticClass: "c_FF7D00" }, [
                            _vm._v("生成中..."),
                          ])
                        : _vm._e(),
                    ]),
                    item.status !== 3
                      ? _c(
                          "div",
                          {
                            staticClass: "task-child-clip-r-status-del",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.delClip(item.id)
                              },
                            },
                          },
                          [_vm._v(" 删除 ")]
                        )
                      : _c("div", { staticClass: "estimated-time" }, [
                          _vm._v(
                            " 预计" + _vm._s(item.percentage) + "分钟完成 "
                          ),
                        ]),
                  ]),
                ]),
              ]),
            ])
          }),
          0
        ),
      ],
      1
    ),
    _vm.clipTask.length
      ? _c(
          "div",
          { staticClass: "footer" },
          [
            _c("span", { staticClass: "footerTotal" }, [
              _vm._v("合计" + _vm._s(_vm.pageConfig.total) + "条"),
            ]),
            _c("pagination", {
              attrs: {
                total: _vm.pageConfig.total,
                current: _vm.pageConfig.current,
                size: _vm.pageConfig.size,
              },
              on: { currentChange: _vm.pageChange },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "task-no-data-icon-box" }, [
      _c("img", {
        staticClass: "task-no-data-icon",
        attrs: { src: require("@/icons/svg/t_nodata.svg"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }